module.exports = __webpack_public_path__ + "static/2-49a85b542d79a1aed2546e8fa7e467e6.jpeg";